export const SHOW_TOAST = 'SHOW_TOAST';
export const showToast = (message, messageType) => (
  { type: SHOW_TOAST, isToastVisible: true, message, messageType }
);

export const HIDE_TOAST = 'HIDE_TOAST';
export const hideToast = () => (
  { type: HIDE_TOAST, isToastVisible: false }
);
